import global from '../utils/global.js'
import Page from './Page.js'
import Form from '../components/Form.js'

export default class ContactPage extends Page {

    static instance

    constructor(parent) {

        if ( ContactPage.instance ) return ContactPage.instance
        super( 'contact' )
        this.parent = parent
        ContactPage.instance = this
        global.views.push( this.view )

    }   

    afterEnter({next}){
    
        const formElement = next.container.querySelector(".contact_form")
         console.log('contact page', formElement)
        if(formElement){
            this.contactForm = new Form(formElement,this)
        }

        console.log(this.contactForm)
        

    }
    
    afterLeave(){

        if(this.contactForm){
            this.contactForm.destroy()
            this.contactForm = null
        }

    }


}
